import {
  emptys,
  itemExtraDataNames,
  occasionalCustomerField,
  occasionalResField,
  personsCodes,
} from "../../../data/main";
import { stdObject } from "../../../data/types/stdObject";
import { sendData } from "../../../services/sendData";
import { checkIfOfferOk } from "./checkIfOfferOk";
import { updateInternalItem } from "./updateInternalItem";

export const savePersonItemData = async (
  { type, code, data, level }: stdObject,
  params: stdObject,
) => {
  const {
    t,
    dispatch,
    countries,
    openErrorMsg,
    personItemField,
    updateInternalPerson,
    windowValues,
    updateDocData,
    selectMode,
    selectStep,
    setMsg2,
    setMsg3,
    setWindowValues,
    setWindowValues2,
    setModalData2,
    setModalData3,
    closeMsg,
    logoutAction,
  } = params;
  let secondData = { ...data };
  secondData.COD = secondData.COD.trim().replace(/\s+/g, " ");
  secondData.NOM = secondData.NOM.trim().replace(/\s+/g, " ");

  let insertInDoc: boolean | string = false;
  if (code !== "" && emptys.includes(secondData.COD)) {
    openErrorMsg(
      {
        code: "warning",
        title: t("p.enterACode"),
      },
      level,
    );
    return false;
  }

  let emptyValues = personItemField
    .filter(
      (e: stdObject) =>
        e.TIPPER === type &&
        e.ACTPER === 1 &&
        e.EXIPER === 1 &&
        e.CODPER !== "TIM",
    )
    .map((e: stdObject) => e.CODPER);
  let isAlready = true;

  for (let a = 0; a < emptyValues.length; a++) {
    if (
      !(emptyValues[a] in secondData) ||
      (typeof secondData[emptyValues[a]] === "string" &&
        secondData[emptyValues[a]].trim() === "")
    ) {
      openErrorMsg(
        {
          code: "warning",
          title: t("p.mandatoryField"),
          label: t(`c.${emptyValues[a]}`),
        },
        level,
      );
      isAlready = false;
      break;
    }
  }
  if (!isAlready) return false;

  if (code === "" || (code !== "" && secondData.COD !== code)) {
    const payloadExists = {
      type,
      code: secondData.COD,
    };
    console.log("payloadExists", payloadExists);
    if (level === 1) {
      setMsg3("loading");
    } else {
      setMsg2("loading");
    }
    const responseExists = await sendData({
      endPoint: "checkCustomerExists",
      payload: payloadExists,
      logoutAction,
    });
    console.log("responseExists", responseExists);

    if (
      !responseExists.success ||
      !responseExists.status ||
      (responseExists.success && responseExists.status && responseExists.exists)
    ) {
      const next_label =
        responseExists.success && responseExists.status && responseExists.exists
          ? t("p.codeAlreadyExists")
          : t("p.error");
      if (level === 1) {
        setMsg3("custom3");
        setModalData3({
          label: next_label,
        });
      } else {
        setMsg2("custom2");
        setModalData2({
          label: next_label,
        });
      }
      return false;
    }
  }

  if (type === "ART" && isAlready) {
    const offerOk = checkIfOfferOk(secondData.PRE.offers);

    if (offerOk.ok) {
      Object.keys(secondData.PRE.offers).forEach((e: string) => {
        secondData.PRE.offers[e] = secondData.PRE.offers[e].map(
          (v: stdObject) => {
            v.DATOFE = Number(v.DATOFE);
            let value =
              v.DATOFE === 1
                ? v.DATES
                : v.DATOFE === 2
                  ? v.DAYS
                  : v.DATOFE === 3
                    ? v.WEEK
                    : "";

            if (v.DATOFE === 3 && Array.isArray(value) && value.length > 0) {
              value = value.map((o) => o ?? 0);
            }

            value =
              Array.isArray(value) && value.length > 0
                ? JSON.stringify(value)
                : "";

            ["DATES", "DAYS", "WEEK", "POROFE"].forEach((o) => {
              if (o in v) {
                if (o === "POROFE" && Number(v.TIPOFE) === 1) {
                  v.PREOFE = v.POROFE;
                }
                delete v[o];
              }
            });

            return { ...v, DAYSOFE: value };
          },
        );
      });
    } else {
      if (level === 1) {
        setModalData3({ code: "warning", label: t(`p.${offerOk.msg}`) });
        setMsg3("custom3");
      } else {
        setModalData2({ code: "warning", label: t(`p.${offerOk.msg}`) });
        setMsg2("custom2");
      }
      return;
    }
  }

  if (isAlready) {
    if (level === 1) {
      setMsg3("loading");
    } else {
      setMsg2("loading");
    }

    let address: Array<stdObject> = [];
    if ("DOM" in secondData) {
      address = [{ DOMDIR: secondData.DOM }];
      delete secondData.DOM;
    }

    let prices: stdObject = {};
    if ("PRE" in secondData) {
      prices = { ...secondData.PRE };
      delete secondData.PRE;
      countries
        .filter((e: stdObject) => e.ACTPAI === 1)
        .forEach((e: stdObject) => {
          if (e.CODPAI in prices.prices) {
            Object.keys(prices.prices[e.CODPAI]).forEach((o) => {
              if (!("TARLTA" in prices.prices[e.CODPAI][o])) {
                prices.prices[e.CODPAI][o].TARLTA = o;
              }
              prices.prices[e.CODPAI][o] = Object.entries(
                prices.prices[e.CODPAI][o],
              );
            });
          }
        });
    }

    if ("insertInDoc" in secondData) {
      if (secondData.insertInDoc) {
        insertInDoc = secondData.insertInDoc;
      }
      delete secondData.insertInDoc;
    }

    if ("TAR" in secondData && emptys.includes(secondData.TAR)) {
    }

    let payloadSavePersonItem: stdObject = {
      type,
      code,
      data: Object.entries(secondData),
    };

    if (personsCodes.includes(type)) {
      payloadSavePersonItem.address = address;
    } else {
      payloadSavePersonItem.prices = prices;
      itemExtraDataNames.forEach((e: string) => {
        payloadSavePersonItem[e] = secondData[e];
      });
      payloadSavePersonItem.IMG = secondData.IMG.images;
      payloadSavePersonItem.data = payloadSavePersonItem.data.filter(
        (e: Array<any>) => !itemExtraDataNames.includes(e[0]),
      );
      const mainIndex = secondData.IMG.images.findIndex(
        (e: stdObject) => !e.DELETE,
      );
      payloadSavePersonItem.data.push([
        "IMG",
        mainIndex === -1 ? "" : secondData.IMG.images[mainIndex].FORIMG,
      ]);
    }

    console.log("payloadSavePersonItem: ", payloadSavePersonItem);

    const responseSavePersonItem: stdObject = await sendData({
      endPoint: personsCodes.includes(type) ? "savePerson" : "saveItem",
      payload: payloadSavePersonItem,
      logoutAction,
    });
    console.log("responseSavePersonItem: ", responseSavePersonItem);
    console.log(
      "responseSavePersonItem: ",
      Object.values(responseSavePersonItem).join(""),
    );

    let finalData: boolean | stdObject = false;
    if (responseSavePersonItem.success) {
      if (responseSavePersonItem.status) {
        if (personsCodes.includes(type)) {
          finalData = updateInternalPerson(
            responseSavePersonItem,
            type,
            dispatch,
          );
          if (insertInDoc && typeof finalData === "object") {
            if ("service" in windowValues) {
              let tempService = windowValues.service;

              (insertInDoc === "RES"
                ? occasionalResField
                : occasionalCustomerField
              ).forEach((e: string) => {
                const prefix = ["CLI", "RES"].includes(e)
                  ? "COD"
                  : e === "NRS"
                    ? "NOM"
                    : e;
                if (`${prefix}CLI` in responseSavePersonItem.data) {
                  tempService[e] = responseSavePersonItem.data[`${prefix}CLI`];
                }
              });
              setWindowValues({ ...windowValues, service: tempService });
            } else {
              updateDocData(finalData, "", {
                goMenu: type,
                target: insertInDoc,
              });
            }
          }
        } else {
          const itemData = updateInternalItem(
            responseSavePersonItem,
            type,
            dispatch,
          );
          if (insertInDoc) {
            updateDocData({ ...itemData.data, CODART: itemData.code }, "ART");
          }
        }

        if (
          typeof finalData === "object" &&
          type === "CLI" &&
          selectMode.serviceStep > 0
        ) {
          selectStep(selectMode.serviceStep, {
            ...finalData,
            [`COD${type}`]: responseSavePersonItem.code,
          });
          closeMsg(3);
        } else {
          if (level === 1) {
            closeMsg(3);
            closeMsg(2);
            setWindowValues2({});
          } else {
            closeMsg(2);
            closeMsg();
            setWindowValues({});
          }
        }
      } else {
        if (level === 1) {
          setMsg3("custom3");
          setModalData3({ label: t("p." + responseSavePersonItem.error) });
        } else {
          setMsg2("custom2");
          setModalData2({ label: t("p." + responseSavePersonItem.error) });
        }
      }
    } else {
      if (level === 1) {
        setMsg3("error");
      } else {
        setMsg2("error");
      }
    }
  } else {
    if (level === 1) {
      setMsg3("error");
    } else {
      setMsg2("error");
    }
  }
};
